import type {FC} from 'react';
import NotFound from '@/components/common/NotFound';
import {useController} from './controller';

const NotFoundPage: FC = () => {
  const {onNavigate} = useController();
  return <NotFound onNavigate={onNavigate} />;
};
export default NotFoundPage;
